/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_Action_GrantInputs */

const en_admin_users_credits_action_grant = /** @type {(inputs: Admin_Users_Credits_Action_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant`)
};

const zh_admin_users_credits_action_grant = /** @type {(inputs: Admin_Users_Credits_Action_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授予`)
};

/**
* | output |
* | --- |
* | "Grant" |
*
* @param {Admin_Users_Credits_Action_GrantInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_action_grant = /** @type {((inputs?: Admin_Users_Credits_Action_GrantInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_Action_GrantInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_action_grant(inputs)
	return zh_admin_users_credits_action_grant(inputs)
});
export { admin_users_credits_action_grant as "admin.users.credits_action_grant" }